// components/Footer.jsx
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Biogenix</h3>
          <p>High-quality anabolic steroid trusted by athletes worldwide.</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: biogenixlaboratories@gmail.com</p>
          <p>Address: Biogenix Pharmaceuticals 896 Lanark Alaska 99654, USA</p>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Biogenix. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
